// API Base URL - uses runtime detection for deployed environments
import { API_BASE_URL } from '../config';
export const API = API_BASE_URL + '/api';
